import React from 'react'
import classes from './FormLabel.module.scss'

export type FormLabelProps = React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>

const FormLabel = ({ children, ...props }: FormLabelProps) => {
  return (
    <label {...props} className={classes.root}>
      {children}
    </label>
  )
}

export default FormLabel
